import { createContext, useContext, ReactNode, useMemo } from 'react';
import { useAuthStore } from '../store/authSlice';

interface AccessContextValue {
  groups: string[];
  groupNames: string[];
  permissions: string[];
  hasPermission: (permission: string) => boolean;
  belongsToGroup: (groupName: string) => boolean;
  isAdmin: boolean;
}

const AccessContext = createContext<AccessContextValue | null>(null);

export function AccessProvider({ children }: { children: ReactNode }) {
  const { user } = useAuthStore();
  
  const value = useMemo<AccessContextValue>(() => {
    const groups = user?.groupIds || [];
    const groupNames = user?.groupNames || [];
    const permissions = user?.permissions || [];

    const hasPermission = (permission: string): boolean => {
      if (user?.isAdmin) return true;
      return permissions.includes(permission);
    };

    const belongsToGroup = (groupName: string): boolean => {
      return groupNames.includes(groupName);
    };

    const isAdmin = user?.isAdmin || false;
    
    console.log('=== AccessProvider === isAdmin:', isAdmin);

    return {
      groups,
      groupNames,
      permissions,
      hasPermission,
      belongsToGroup,
      isAdmin,
    };
  }, [user]);

  return (
    <AccessContext.Provider value={value}>
      {children}
    </AccessContext.Provider>
  );
}

export function useAccess(): AccessContextValue {
  const ctx = useContext(AccessContext);
  if (!ctx) {
    throw new Error('useAccess must be used within AccessProvider');
  }
  return ctx;
}
